var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.358 15.4C29.358 23.1088 23.1088 29.358 15.4 29.358C7.69118 29.358 1.44196 23.1088 1.44196 15.4C1.44196 7.6912 7.69118 1.44198 15.4 1.44198C23.1088 1.44198 29.358 7.6912 29.358 15.4Z",
    fill: "#EB6502",
    stroke: "#E2E2E2",
    strokeWidth: 1.28395
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2332 10.8109C11.4784 10.5656 11.876 10.5656 12.1213 10.8109L15.445 14.1346L18.7688 10.8109C19.0141 10.5656 19.4117 10.5656 19.6569 10.8109C19.9022 11.0561 19.9022 11.4537 19.6569 11.6989L16.3331 15.0227L19.6569 18.3465C19.9022 18.5917 19.9022 18.9893 19.6569 19.2346C19.4117 19.4798 19.0141 19.4798 18.7688 19.2346L15.445 15.9108L12.1213 19.2346C11.876 19.4798 11.4784 19.4798 11.2332 19.2346C10.9879 18.9893 10.9879 18.5917 11.2332 18.3465L14.557 15.0227L11.2332 11.6989C10.9879 11.4537 10.9879 11.0561 11.2332 10.8109Z",
    fill: "#E2E2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatclose);
export default __webpack_public_path__ + "static/media/chatclose.291a0ece6e9dc115bfbf9273ccba4f91.svg";
export { ForwardRef as ReactComponent };